<template>
    <div class="Order">
        <div class="OrderTop" v-if="false">
            <div class="Nav">
                <div class="NavItem" :class="{Act:i==1}" @click="ToggleNav(1)">会员订单</div>
                <div class="NavItem" :class="{Act:i==2}" @click="ToggleNav(2)">参会订单</div>
                <div class="NavItem" :class="{Act:i==3}" @click="ToggleNav(3)">住宿订单</div>
                <div class="NavItem" :class="{Act:i==4}" @click="ToggleNav(4)">单位会员订单</div>
                <div class="NavItem" :class="{Act:i==5}" @click="ToggleNav(5)">委员会订单</div>
            </div>
            <!-- <div class="NavMsg">技术支持:camhts2022@163.com</div> -->
        </div>
        <div class="table-container">
            <el-table 
                :data="tableData" 
                style="width: 100%;"
                border>
                <el-table-column cell-class-name="custom-text-size" prop="id" label="ID" width="80"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="order_no" label="订单号" width="150"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="type" label="注册类型" width="100">
                    <template slot-scope="scope">
                        {{ getTypeText(scope.row.type) }}
                    </template>
                </el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="content.group_name" label="类型名称" width="120"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="content.name" label="名称" width="300"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="content.mobile" label="电话" width="120"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="price_type" label="费用类型" width="120">
                    <template slot-scope="scope">
                        {{ getPriceTypeText(scope.row.price_type, scope.row.type) }}
                    </template>
                </el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="pay_status" label="支付状态" width="120">
                    <template slot-scope="scope">
                        <span :class="scope.row.pay_status === 1 ? 'status-paid' : 'status-unpaid'">
                            {{ getPayStatusText(scope.row.pay_status) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="price" label="支付金额" width="100"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="createtime" label="订单时间" width="120"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" label="操作" width="200" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.pay_status === 2" class="ColorBlue" size="mini" @click="LockInfo(scope.row)">去支付</el-button>
                        <el-button 
                            class="ColorBlue" 
                            size="mini" 
                            @click="showInvoiceDialog(scope.row)"
                        >
                            {{hasInvoiceInfo(scope.row) ? '发票信息' : '去开票'}}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="PageDis">
            <el-pagination background :page-sizes="[5,10, 20, 50]" layout="prev,pager,next,total,sizes"  @size-change="SizeChange" @current-change="PageChange" :total="total" :current-page="page" :hide-on-single-page="false"></el-pagination>
        </div>

        <!-- 发票信息弹窗 -->
        <el-dialog title="发票信息" :visible.sync="invoiceDialogVisible" width="500px">
            <el-form :model="invoiceForm" label-width="100px">
                <el-form-item label="发票抬头">
                    <el-input v-model="invoiceForm.title" placeholder="请输入发票抬头"></el-input>
                </el-form-item>
                <el-form-item label="发票项目信息">
                    <el-input v-model="invoiceForm.projectInfo" placeholder="请输入发票项目信息"></el-input>
                </el-form-item>
                <el-form-item label="税号">
                    <el-input v-model="invoiceForm.taxNumber" placeholder="请输入税号"></el-input>
                </el-form-item>
                <el-form-item label="邮箱">
                    <el-input v-model="invoiceForm.email" placeholder="请输入接收发票的邮箱"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="invoiceDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitInvoice">提交</el-button>
            </div>
        </el-dialog>

        <!-- 支付二维码弹窗 -->
        <el-dialog 
            title="" 
            :visible.sync="qrCodeDialogVisible" 
            width="500px" 
            center 
            :show-close="false"
            custom-class="payment-dialog"
            :modal-append-to-body="false"
            :append-to-body="false"
        >
            <div class="wrap">
                <div class="card">
                    <div class="brand">
                        <img class="logo" src="../../assets/img/logo.jpg" alt="logo" />
                        <h1 class="title">中国心理卫生协会</h1>
                    </div>
                    <p class="subtitle">支持微信，支付宝，云闪付等钱包扫码支付</p>
                    <div class="status">
                        <span class="dot"></span>
                        <span>等待支付中</span>
                    </div>
                    <div class="qrcode-box">
                        <canvas id="qrcode" width="260" height="260"></canvas>
                    </div>
                    <div class="meta">
                        <div class="row">
                            <span class="key" style="font-size:20px">支付金额：</span>
                            <span style="font-weight:600;color:#111827;font-size:25px">￥{{ currentPaymentAmount }}</span>
                        </div>
                    </div>
                    <div class="actions">
                        <button class="btn" @click="cancelPayment">取消支付</button>
                        <button class="btn primary" @click="confirmPayment">已完成支付</button>
                    </div>
                    <div class="tips">若已支付成功，请点击"已完成支付"返回订单页查看状态</div>
                    <!-- <div class="help">
                        温馨提示：
                        <ol style="margin:6px 0 0 16px; padding:0;">
                            <li>二维码有效期内可重复扫码；如失效请返回订单页重新发起支付。</li>
                            <li>支付金额较大时，使用微信支付可能遇到限额问题，建议使用支付宝或者云闪付支付。</li>
                        </ol>
                    </div> -->
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import QRCode from 'qrcode';
    export default {
        data() {
            return {
                i:1,
                tableData:[
                    // {id: '1',name: '测试',phone: '13888888888',type:"测试",money:"300",time:"2024-11-14",state:"待支付"}
                ],
                total:0,
                page:1,
                SizePage:10,
                invoiceDialogVisible: false,
                invoiceForm: {
                    title: '',
                    projectInfo: '',
                    taxNumber: '',
                    email: ''
                },
                currentOrder: null,
                qrCodeDialogVisible: false, // 新增的二维码弹窗可见性
                currentPaymentAmount: 0 // 新增的当前支付金额
            }
        },
        mounted() {
            this.GetOrderList();
        },
        methods: {
            ToggleNav(i){
                this.i = i;
            },
            getTypeText(type) {
                const typeMap = {
                    1: '项目',
                    2: '专业人员',
                    3: '专业机构'
                };
                return typeMap[type] || '未知';
            },
            getPriceTypeText(type, orderType) {
                // 专业机构使用新的费用类型
                if (orderType === 3) {
                    const typeMap = {
                        1: '线下评审费',
                        2: '注册管理费',
                        3: '资料评审费',
                        4: '项目费'
                    };
                    return typeMap[type] || '未知';
                } else {
                    // 专业人员和项目使用原来的费用类型
                    const typeMap = {
                        1: '审核费',
                        2: '注册费',
                        3: '申请费',
                        4: '项目费'
                    };
                    return typeMap[type] || '未知';
                }
            },
            getPayStatusText(status) {
                const statusMap = {
                    1: '已支付',
                    2: '未支付'
                };
                return statusMap[status] || '未知';
            },
            GetOrderList() {
                this.$get("api/user/orderList", {
                    page: this.page,
                    limit: this.SizePage
                }).then(res => {
                    if(res.data.code == 1) {
                        this.tableData = res.data.data.data;
                        this.total = res.data.data.total;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            },
            LockInfo(row){
                this.currentOrder = row; // 设置当前订单
                const payload = {
                    amount: row.price,
                    orderNumber: row.order_no,
                    name: row.content && row.content.name ? row.content.name : '',
                    mobile: row.content && row.content.mobile ? row.content.mobile : '',
                    tag: row.id
                };
                this.$post('https://rps.camh.org.cn/api/Unionpay/doUnionPay', payload).then(res => {
                    if(res && res.data && res.data.code === 200 && res.data.data && res.data.data.src){
                        // window.open(res.data.data.src, '_blank'); // Original line commented out
                        this.displayQRCode(res.data.data.src);
                    } else {
                        this.$message.error((res && res.data && res.data.msg) ? res.data.msg : '支付发起失败');
                    }
                }).catch(() => {
                    this.$message.error('网络错误，请稍后重试');
                });
            },
            displayQRCode(url) {
                this.currentPaymentAmount = this.currentOrder ? this.currentOrder.price : 0;
                this.qrCodeDialogVisible = true;
                this.$nextTick(() => {
                    // 强制移除弹窗的白色背景
                    this.removeDialogBackground();
                    
                    const canvas = document.getElementById('qrcode');
                    if (canvas) {
                        QRCode.toCanvas(canvas, url, {
                            width: 260,
                            height: 260,
                            margin: 2
                        }, (error) => {
                            if (error) {
                                console.error(error);
                                this.$message.error('生成二维码失败');
                            }
                        });
                    }
                });
            },
            removeDialogBackground() {
                // 动态移除弹窗白色背景
                setTimeout(() => {
                    const dialog = document.querySelector('.payment-dialog');
                    if (dialog) {
                        dialog.style.background = 'transparent';
                        dialog.style.boxShadow = 'none';
                        dialog.style.border = 'none';
                        
                        const header = dialog.querySelector('.el-dialog__header');
                        if (header) header.style.display = 'none';
                        
                        const body = dialog.querySelector('.el-dialog__body');
                        if (body) body.style.background = 'transparent';
                    }
                }, 100);
            },
            showInvoiceDialog(row) {
                this.currentOrder = row;
                this.invoiceDialogVisible = true;
                // 获取费用类型文本
                const priceTypeText = this.getPriceTypeText(row.price_type, row.type);
                
                // 如果已有发票信息则加载已有信息
                if (this.hasInvoiceInfo(row)) {
                    this.invoiceForm = {
                        title: row.invoice_head,
                        projectInfo: row.invoice_info || priceTypeText, // 如果发票信息为空，使用费用类型
                        taxNumber: row.invoice_tax_id,
                        email: row.invoice_email
                    };
                } else {
                    // 如果没有发票信息，则使用默认值
                    this.invoiceForm = {
                        title: '',
                        projectInfo: priceTypeText,  // 自动填入费用类型
                        taxNumber: '',
                        email: ''
                    };
                }
            },
            submitInvoice() {
                if (!this.invoiceForm.title || !this.invoiceForm.projectInfo || 
                    !this.invoiceForm.taxNumber || !this.invoiceForm.email) {
                    this.$message.error('请填写完整的发票信息');
                    return;
                }
                
                this.$post("api/user/saveInvoice", {
                    order_id: this.currentOrder.id,
                    invoice_head: this.invoiceForm.title,
                    invoice_info: this.invoiceForm.projectInfo,
                    invoice_tax_id: this.invoiceForm.taxNumber,
                    invoice_email: this.invoiceForm.email
                }).then(res => {
                    if (res.data.code == 1) {
                        this.$message.success('发票信息提交成功');
                        this.invoiceDialogVisible = false;
                        this.GetOrderList(); // 刷新列表
                    } else {
                        this.$message.error(res.data.msg || '提交失败');
                    }
                }).catch(() => {
                    this.$message.error('网络错误，请稍后重试');
                });
            },
            SizeChange(val) {
                this.SizePage = val;
                this.GetOrderList();
            },
            PageChange(val) {
                this.page = val;
                this.GetOrderList();
            },
            hasInvoiceInfo(row) {
                return row.invoice_head || row.invoice_info || row.invoice_tax_id || row.invoice_email;
            },
            // 新增的支付相关方法
            cancelPayment() {
                // this.$message.info('支付已取消');
                this.qrCodeDialogVisible = false;
                this.currentPaymentAmount = 0; // 重置金额
            },
            confirmPayment() {
                // this.$message.success('支付已完成');
                this.qrCodeDialogVisible = false;
                this.currentPaymentAmount = 0; // 重置金额
                this.GetOrderList(); // 刷新订单列表
            }
        },
    }
</script>
<style scoped>
    .custom-text-size{
        font-size: 16px;
        text-align: center;
    }
    .status-paid {
        color: #0385EB;
        font-weight: bold;
    }
    .status-unpaid {
        color: #ff6b6b;
        font-weight: bold;
    }
    /* 确保表头也居中 */
    ::v-deep .el-table th {
        text-align: center;
        color: #303030;
        font-weight: bold;
    }
    /* 确保表格内容居中 */
    ::v-deep .el-table td {
        text-align: center;
    }
    /* 确保表格中的按钮和其他元素居中 */
    ::v-deep .el-table .cell {
        text-align: center;
    }
    .OrderTop{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 2px solid #ddd;
        position: relative;
        margin-bottom: 20px;
        width: 100%;
    }
    .Nav{
        flex: 1;
        display: flex;
        align-items: center;
    }
    .NavItem{
        font-size: 16px;
        min-width: 120px;
        padding: 15px 0;
        text-align: center;
        font-weight: 400;
        color: #666666;
        cursor: pointer;
        position: relative;
        flex-shrink: 0;
    }
    .NavItem.Act{
        color: #e69d26;
        /* font-weight: 600; */
    }
    .NavItem.Act::after{
        content: "";
        position: absolute;
        width: 100%;
        height: 2px;
        background: #e69d26;
        bottom: -2px;
        left: 0;
    }
    .NavMsg{
        color: #666;
        font-size: 16px;
    }
    .PageDis{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }
    .table-container {
        width: 100%;
        max-width: 890px;
        margin: 0 0 20px;
        overflow-x: auto;
        position: relative;
        padding-bottom: 5px;
    }
    .table-container::-webkit-scrollbar {
        width: 100%;
        height: 6px;
        background-color: #f5f5f5;
        border-radius: 3px;
    }
    .table-container::-webkit-scrollbar-thumb {
        background: #909399;
        border-radius: 3px;
        cursor: pointer;
    }
    .table-container::-webkit-scrollbar-thumb:hover {
        background: #606266;
    }
    .table-container::-webkit-scrollbar-track {
        background: #e4e7ed;
        border-radius: 3px;
    }
    .table-container::-webkit-scrollbar-track:hover {
        background: #dcdfe6;
    }
    .qr-code-container {
        text-align: center;
        padding: 20px;
    }
    .qr-code-container canvas {
        margin: 0 auto;
        display: block;
    }
    .qr-tip {
        margin-top: 15px;
        color: #666;
        font-size: 14px;
        text-align: center;
    }
    /* 新增的支付对话框样式 */
    .payment-dialog .el-dialog__body {
        padding: 0; /* 移除默认的内边距 */
    }
    /* 移除弹窗四周的白色背景 */
    .payment-dialog .el-dialog {
        background: transparent !important;
        box-shadow: none !important;
        border: none !important;
    }
    .payment-dialog .el-dialog__header {
        display: none !important; /* 隐藏标题栏 */
    }
    .payment-dialog .el-dialog__body {
        padding: 0 !important;
        background: transparent !important;
    }
    /* 确保弹窗遮罩层透明 */
    .payment-dialog .el-dialog__wrapper {
        background-color: rgba(0, 0, 0, 0.5) !important;
    }
    /* 全局覆盖弹窗样式 */
    ::v-deep .payment-dialog .el-dialog {
        background: transparent !important;
        box-shadow: none !important;
        border: none !important;
    }
    ::v-deep .payment-dialog .el-dialog__header {
        display: none !important;
    }
    ::v-deep .payment-dialog .el-dialog__body {
        padding: 0 !important;
        background: transparent !important;
    }
    ::v-deep .payment-dialog .el-dialog__wrapper {
        background-color: rgba(0, 0, 0, 0.5) !important;
    }
    /* 更强制性的全局样式覆盖 */
    ::v-deep .el-dialog.payment-dialog {
        background: transparent !important;
        box-shadow: none !important;
        border: none !important;
    }
    ::v-deep .el-dialog.payment-dialog .el-dialog__header {
        display: none !important;
    }
    ::v-deep .el-dialog.payment-dialog .el-dialog__body {
        padding: 0 !important;
        background: transparent !important;
    }
    ::v-deep .el-dialog.payment-dialog .el-dialog__wrapper {
        background-color: rgba(0, 0, 0, 0.5) !important;
    }
    /* 使用全局选择器强制覆盖 */
    :global(.payment-dialog .el-dialog) {
        background: transparent !important;
        box-shadow: none !important;
        border: none !important;
    }
    :global(.payment-dialog .el-dialog__header) {
        display: none !important;
    }
    :global(.payment-dialog .el-dialog__body) {
        padding: 0 !important;
        background: transparent !important;
    }
    :global(.payment-dialog .el-dialog__wrapper) {
        background-color: rgba(0, 0, 0, 0.5) !important;
    }
    .payment-dialog .wrap {
        padding: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 300px; /* 减少高度 */
    }
    .payment-dialog .card {
        background-color: #fff;
        border-radius: 20px; /* 增加圆角 */
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        padding: 25px; /* 减少内边距 */
        width: 100%;
        max-width: 400px; /* 减少最大宽度 */
        text-align: center;
    }
    .payment-dialog .brand {
        margin-bottom: 15px; /* 减少底部边距 */
        display: flex; /* 改为flex布局 */
        align-items: center; /* 垂直居中 */
        justify-content: center; /* 水平居中 */
        gap: 10px; /* logo和标题之间的间距 */
    }
    .payment-dialog .brand .logo {
        width: 50px; /* 减少logo尺寸 */
        height: 50px;
        margin-bottom: 0; /* 移除底部边距 */
        border-radius: 50%;
        object-fit: cover;
    }
    .payment-dialog .brand .title {
        font-size: 20px; /* 减少字体大小 */
        color: #333;
        margin-bottom: 0; /* 移除底部边距 */
    }
    .payment-dialog .subtitle {
        font-size: 14px; /* 减少字体大小 */
        color: #666;
        margin-bottom: 15px; /* 减少底部边距 */
    }
    .payment-dialog .status {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px; /* 减少底部边距 */
    }
    .payment-dialog .status .dot {
        width: 8px; /* 减少点的大小 */
        height: 8px;
        background-color: #4CAF50;
        border-radius: 50%;
        margin-right: 8px;
    }
    .payment-dialog .status span {
        font-size: 16px; /* 减少字体大小 */
        color: #333;
    }
    .payment-dialog .qrcode-box {
        margin-bottom: 20px; /* 减少底部边距 */
    }
    .payment-dialog .qrcode-box canvas {
        border: 1px solid #eee;
        border-radius: 8px;
    }
    .payment-dialog .meta {
        margin-bottom: 20px; /* 减少底部边距 */
    }
    .payment-dialog .meta .row {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .payment-dialog .meta .key {
        margin-right: 10px;
    }
    .payment-dialog .actions {
        display: flex;
        justify-content: space-around;
        margin-bottom: 15px; /* 减少底部边距 */
    }
    .payment-dialog .actions .btn {
        padding: 8px 16px; /* 减少按钮内边距 */
        border: none;
        border-radius: 8px;
        cursor: pointer;
        font-size: 14px; /* 减少字体大小 */
        font-weight: 600;
        transition: background-color 0.3s ease;
    }
    .payment-dialog .actions .btn:hover {
        opacity: 0.9;
    }
    .payment-dialog .actions .btn.primary {
        background-color: #4CAF50;
        color: white;
    }
    .payment-dialog .actions .btn.primary:hover {
        background-color: #45a049;
    }
    .payment-dialog .actions .btn:last-child {
        background-color: #f44336;
        color: white;
    }
    .payment-dialog .actions .btn:last-child:hover {
        background-color: #d32f2f;
    }
    .payment-dialog .tips {
        font-size: 12px; /* 减少字体大小 */
        color: #666;
        margin-bottom: 15px; /* 减少底部边距 */
    }
    .payment-dialog .help {
        font-size: 12px;
        color: #999;
        line-height: 1.6;
    }
    .payment-dialog .help ol {
        margin-top: 10px;
    }
    .payment-dialog .help li {
        margin-bottom: 5px;
    }
   @media only screen and (max-width: 550px) {
       
   }
</style>